var PATTERN_1 = require("./pattern-1");

var PATTERN_2 = require("./pattern-2");

var PATTERN_3 = require("./pattern-3");

var PATTERN_4 = require("./pattern-4");

var PATTERN_5 = require("./pattern-5");

var PATTERN_6 = require("./pattern-6");

var PATTERN_7 = require("./pattern-7");

var PATTERN_8 = require("./pattern-8");

export default [PATTERN_1, PATTERN_2, PATTERN_3, PATTERN_4, PATTERN_5, PATTERN_6, PATTERN_7, PATTERN_8];